import React from 'react';
import { ArrowRight } from 'lucide-react';
import { bridalContent, siteInfo } from '../data/mock';

const BridalSection = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      `Hola Luciana, me caso y me gustaría información sobre tus servicios de maquillaje y peinado para novias. ¡Gracias!`
    );
    window.open(`https://wa.me/${siteInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <section id="novias" className="section-padding bg-[#fffef2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Label */}
        <div className="text-center mb-16">
          <p className="hero-subtitle text-[#666] mb-4">
            Exclusivo
          </p>
          <h2 className="section-title text-[#333] mb-2">
            {bridalContent.sectionTitle}
          </h2>
          <div className="w-16 h-[1px] bg-[#333] mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Image */}
          <div className="relative lg:sticky lg:top-32">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={bridalContent.image}
                alt="Novia maquillada por Luciana Belén"
                className="w-full h-full object-cover object-top img-hover"
              />
            </div>
            {/* Decorative frame */}
            <div className="absolute -inset-4 border border-[#bcbbb4] -z-10" />
          </div>

          {/* Content */}
          <div>
            <h3 className="font-display text-3xl lg:text-4xl font-light text-[#333] mb-8 leading-tight">
              {bridalContent.title}
            </h3>
            
            {/* Description paragraphs */}
            <div className="space-y-6 mb-10">
              {bridalContent.description.map((paragraph, index) => (
                <p key={index} className="body-large text-[#666] leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* CTA */}
            <button
              onClick={handleWhatsApp}
              className="btn-primary group"
            >
              {bridalContent.cta}
              <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>

        {/* Logo grande para transición */}
        <div className="mt-20 text-center">
          <p className="font-display text-4xl lg:text-5xl font-light tracking-[0.15em] text-[#333]">
            LUCIANA BELÉN
          </p>
        </div>
      </div>
    </section>
  );
};

export default BridalSection;
